import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { label: '首页', path: '/' },
      { label: '文章分类', path: '/category' },
      { label: '关于我们', path: '/about' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '母子边界模糊', path: '/category?tab=boundary' },
      { label: '母子情感依赖', path: '/category?tab=dependency' },
      { label: '依恋障碍', path: '/category?tab=attachment' },
      { label: '家庭心理咨询', path: '/category?tab=counseling' },
    ],
  },
  {
    title: '帮助与支持',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '常见问题', path: '/#faq' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-800 text-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-heart-pulse-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">
                母子心理健康
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              以专业心理学知识守护每一个家庭的亲子关系健康。提供科学的心理分析与干预指南。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 母子关系心理健康指南. 本站内容仅供心理健康科普参考，不能替代专业心理诊断与治疗。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-400 hover:text-background-200 transition-colors" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}